// extracted by mini-css-extract-plugin
module.exports = {"arco-layout":"arco-layout"};